/**
 * Author: ligj@mapbar.com
 * Create Time: 2018/01/05 15:07
 * Description:
 */

import Vue from 'vue'
import Vuex from 'vuex'

import modal from './modules/modal'
import tabView from './modules/tabView'

import breadcrumb from './modules/breadcrumb'
Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default function ({state, mutations, actions, modules}) {
    return new Vuex.Store({
        state,
        mutations,
        actions,
        modules: {
            ...modules,
            modal,
            tabView,
            breadcrumb,
        },
        strict: debug,
        plugins: []
    })
};
